import BaseRepository from '@/api/repositories/BaseRepository';

export default class DashboardRepository extends BaseRepository {
	getDashboard(options = {}) {
		return this.get('dashboard', options);
	}

	getAllVideos() {
		return this.get('dashboard-videos', {});
	}

	getVideoById(id) {
		return this.get(`dashboard-videos/${id}`, {}, { responseType: 'blob' });
	}
}
